import React, { FC, useState } from "react";
import { withStyles, createStyles, WithStyles } from "@material-ui/core";
import { connect } from "react-redux";
import { IState } from "@mochi/core";
import { theme } from "../";

interface IProps extends WithStyles<typeof styles> {
  removeBackground?: boolean;
  closing?: boolean;
}

const styles = () =>
  createStyles({
    background: {
      content: '""',
      width: "100%",
      height: "100%",
      position: "fixed",
      backgroundColor: `${theme.palette.text.primary}`,
      zIndex: 99999,
      opacity: 0.75
    },
    root: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      "& #circle": {
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        width: 120,
        height: 120,
        zIndex: 999999
      },
      "& .loader": {
        width: "calc(100% - 0px)",
        height: "calc(100% - 0px)",
        border: `6px solid ${theme.palette.secondary.main}`,
        borderTop: `6px solid ${theme.palette.primary.main}`,
        borderRadius: "50%",
        animation: "rotate 5.5s ease-out infinite"
      }
    },
    "@global": {
      "@keyframes rotate": {
        "100%": { transform: "rotate(360deg)" }
      },
      "*, ::after, ::before": {
        "box-sizing": "border-box"
      }
    }
  });

const Progress: FC<IProps> = ({ classes, removeBackground, closing }) => {
  const [isClosed, setIsClosed] = useState(true);
  const [timer, setTimer] = useState<any>(undefined);
  React.useEffect(() => {
    if (!closing) {
      // if last call is "opening"
      // just open

      setIsClosed(false);
      if (timer) {
        // progress is waiting for "closing"
        // don't wait
        clearTimeout(timer);
        setTimer(undefined);
      }
      return;
    }
    if (closing && !isClosed) {
      // last call is "closing"
      // progress is "opening"
      // wait for closing

      const timeout = setTimeout(() => {
        setIsClosed(true);
        clearTimeout(timer);
        setTimer(undefined);
      }, 750);
      setTimer(timeout);
      setIsClosed(false);
    }
  }, [closing, isClosed, timer]);
  if (isClosed) {
    return <React.Fragment />;
  }
  return (
    <div className={classes.root}>
      {!removeBackground && <div className={classes.background} />}
      <div id="circle">
        <div className="loader">
          <div className="loader">
            <div className="loader">
              <div className="loader" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ConnectedProgress = connect(
  <State extends IState>(state: State) => ({
    closing: !state.fetchApi.isFetchingWithLoading
  })
)(withStyles(styles)(Progress));
